<template>
  <div>
    <v-navigation-drawer
          v-if='drawerOpen'
          class=""
          width="450"
          right
          absolute
          permanent
          app
          > 
        <v-toolbar
        :color="+(activeParticipants) ? '#85d56c' : 'primary'"
        flat
        
        >
          <v-btn :dark="+(activeParticipants) ? false : true" icon x-large @click='closeDrawer'><v-icon>mdi-close-circle</v-icon></v-btn>
           
          <v-spacer></v-spacer>
          <v-btn v-if='!session' rounded large @click="connectWithBestToken()">
            <v-icon>mdi-phone</v-icon>
            Click to Join
          </v-btn>
          <v-spacer></v-spacer>
          <div 
            v-if="session"
            class="text-center d-flex align-center justify-space-around"
          >
          <v-row class="mb-1" no-gutters>
            <v-col class='mr-1'>
              <v-btn 
                @click='$sip.bye()' 
                dark
                color="red" 
                fab
                small
                class='ml-1'>
                  <v-icon>mdi-phone-hangup-outline</v-icon>
              </v-btn>
            </v-col>
            <v-col class='mr-1'>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn 
                      v-if="session.state == 'Established' &&  activeParticipants" 
                      @click='addDisplay()'
                      color="teal" 
                      dark
                      fab
                      small
                      v-bind="attrs"
                      v-on="on">
                        <v-icon>mdi-monitor-share</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Share Screen</span>
              </v-tooltip>
            </v-col>
            <v-col class='mr-1'>
              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <v-btn 
                    v-if="session.state == 'Established' &&  activeParticipants && (!session.isMuted && !myChannel.id) || (!myChannel.muted && myChannel.id)" 
                    @click='myChannel.id !== null ? muteCaller(myChannel) : $sip.mute(true)' 
                    color="teal" 
                    dark
                    fab
                    small
                    v-bind="attrs"
                    v-on="on">
                      <v-icon>mdi-microphone</v-icon>
                  </v-btn>
                  <v-btn 
                    v-if="session.state == 'Established' && activeParticipants && (session.isMuted && !myChannel.id) || (myChannel.muted && myChannel.id)" 
                    @click='myChannel.id !== null ? unmuteCaller(myChannel) : $sip.mute(false)' 
                    color="teal" 
                    dark
                    fab
                    small
                    v-bind="attrs"
                    v-on="on">
                      <v-icon>mdi-microphone-off</v-icon>
                  </v-btn>
                </div>
              </template>
              <span v-if="(!session.isMuted && !myChannel.id) || (!myChannel.muted && myChannel.id)">Mute</span>
              <span v-if="(session.isMuted && myChannel.id) || (myChannel.muted && myChannel.id)">Un-Mute</span>
            </v-tooltip>
            </v-col>
          </v-row>
          </div>
          <v-btn v-if='activeParticipants' :dark="+(activeParticipants) ? false : true" fab small @click='raiseHand()'><v-icon>mdi-hand-right</v-icon></v-btn>
          <media-input-selector :dark="+(activeParticipants) ? false : true" ></media-input-selector>
          
        </v-toolbar>
        
        <v-tabs align-with-title v-model='activeTab' style='overflow:hidden;'>
          <v-tabs-slider color='primary'></v-tabs-slider>
          <v-tab v-if="activeParticipants" key='participants'>Participants</v-tab>
          <v-tab key='join'>Join Info</v-tab>
          <v-tab key='settings'>Settings</v-tab>
          <v-tab-item v-if="activeParticipants" key='participants' style='max-height:85vh; overflow:auto;'>
            <conference-participants-list></conference-participants-list>
          </v-tab-item>
          <v-tab-item key='join' style='max-height:85vh; overflow:auto;'>
            <join-info></join-info>
          </v-tab-item>
          <v-tab-item key='settings' style='max-height:85vh; overflow:auto;'>
            <conference-settings :conf="this.conf"></conference-settings>
          </v-tab-item>
        </v-tabs>       
    </v-navigation-drawer>
  </div>
</template>
<style scoped>

.v-list-item--link::before { background-color: red; }
</style>
<script >
import ConferenceCommon from '../mixins/conferencecommon.vue';
import Common from '../mixins/common.vue';
import MediaInputSelector from '../components/media-input-selector.vue';
import JoinInfo from '../components/conference-joining-info.vue';
import ConferenceSettings from '../components/conference-settings.vue';
import ConferenceParticipantsList from '../components/conference-participant-list.vue';

export default {
  data: function() {
    return {
      activeTab: null,
    }
  },
  props: {
    drawerOpen: Boolean
  },
  components: {
    'media-input-selector': MediaInputSelector,
    'join-info': JoinInfo,
    'conference-settings': ConferenceSettings,
    'conference-participants-list': ConferenceParticipantsList
  },
  
  mixins: [ConferenceCommon, Common,
    ConferenceSettings ],
  methods: {
    closeDrawer: function() {
      this.$parent.drawerOpen = false;
    },
    logState: function() {
      console.log(this.session);
    },
    logTab: function() {
      console.log(this.activeTab);
    },
    switchTab: function(num) {
      this.activeTab=num;
      console.log('switching tab to ', num)
    },
    addDisplay() { this.$sip.display(); },
  },
  computed: {
    session: {
      get() { return this.$store.getters['sip/session'] },
    },
    state: {
      get: function() {
        if (this.session) {
          return this.session.state;
        }
        return null;
      }
    },
  },
  watch: {
    activeParticipants: function(newval, oldval) {
      if (newval) {
        this.switchTab(2)
        console.log('change to activeParticipants, switching tabs')
      }
    }
  },
  async mounted() {
    
  }
  
}
</script>

<style scoped> 
/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: gray transparent;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 8px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: gray;
}
.v-navigation-drawer__content {
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0em;
  z-index: 2;
}
</style>